<div
  *ngIf="!isMobileDevice; else mobileTooltip"
  class="tooltip"
  [ngClass]="{'custom-icon': bulletIconName}"
  [style.width]="width+'px'"
  [style.height]="height+'px'"
  [style.color]="tooltipTextColor"
  [style.background-color]="bulletBackgroundColor"
  (mouseenter)="toggleTooltip($event)"
  (keyup.enter)="toggleTooltip($event)"
  (mouseleave)="toggleTooltip($event, false)"
  (blur)="toggleTooltip($event, false)"
  tabindex="{{tabIndex}}"
  role="button"
>
  <ng-container *ngTemplateOutlet="tooltipContent"></ng-container>
</div>

<ng-template #mobileTooltip>
  <div
    class="tooltip"
    [ngClass]="{'custom-icon': bulletIconName}"
    (click)="toggleTooltip($event)"
    [style.width]="width+'px'"
    [style.height]="height+'px'"
    [style.color]="tooltipTextColor"
    [style.background-color]="bulletBackgroundColor"
  >
    <ng-container *ngTemplateOutlet="tooltipContent"></ng-container>
  </div>
</ng-template>

<ng-template #tooltipContent>
  <span class="tooltip__info"
        [style.font-size]="fontSize"
        [style.color]="bulletTextColor"
  >
    <ng-container *ngIf="bulletIconName; else infoLetter">
      <mm-icon class="tooltip__icon" [isCurrentColor]="false" [name]="bulletIconName"></mm-icon>
    </ng-container>
    <ng-template #infoLetter>i</ng-template>
  </span>
  <div *ngIf="isVisible" [style.background-color]="tooltipBackgroundColor" [ngClass]="{
        'tooltip__overlay': !withBorders && !newOverlay,
        'tooltip__new-overlay': newOverlay,
        'tooltip__overlay--left': !withBorders && position === positions.left,
        'tooltip__overlay--right': !withBorders && position === positions.right,
        'tooltip__overlay--top': position === positions.top,
        'tooltip__overlay--bottom-right': !withBorders && position === positions.bottomRight,
        'tooltip__new-overlay--top-left': !withBorders && newOverlay && position === positions.topLeft,
        'tooltip__new-overlay--top-right': !withBorders && newOverlay && position === positions.topRight,
        'tooltip__overlay-with-borders': withBorders,
        'tooltip__overlay-with-borders--left': withBorders && position === positions.left,
        'tooltip__overlay-with-borders--right': withBorders &&  position === positions.right
      }">
    <ng-content></ng-content>
  </div>
</ng-template>
